import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { func } from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
import MenuIcon from "@material-ui/icons/Menu";

import { Grid } from "@material-ui/core";

import DesktopHeader from "./DesktopHeader";
import brandTheme from "brandTheme/Theme";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import { parseAndSetFlag } from "utils/Utils";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: brandTheme.headerBackGroundColor,
    width: "100%",
    flexWrap: "wrap",
    padding: "0 10px",
  },

  logoSection: {
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      width: "100%",
    },
  },

  logo: {
    height: "60px",
    margin: "10px 0px 0px 20px",

    [theme.breakpoints.down("sm")]: {
      height: "45px",
      margin: "10px auto",
    },
  },

  mobileTopRow: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  mobileBranch: {
    width: "100%",
    padding: "10px",

    [theme.breakpoints.down("sm")]: {
      padding: "10px 0",
    },
  },
  mobileHeader: {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
},
}));

const Header = ({
  handleDrawerToggle, userDetailData
}) => {
  const classes = useStyles();
  const [logo, setLogo] = useState("");
  const [callInProgress, setCallInProgress] = useState(false);
  const { enabled } = useSelector((state) => state?.login?.adminPortalData) || false;
  const { authToken } = useSelector(
      (state) => state.login.authData
    );
  useEffect(() => {
    if (!logo) {
      GetLogoLink();
    }
  }, [logo]);

  const GetLogoLink = () => {
    setCallInProgress(true);

    apiHandler({
      url: endpoint.LOGO_URL,
      method: "GET",
    })
      .then((result) => {
        if (result?.data?.logo) {
          setLogo(result?.data?.logo);
        }
      })
      .catch((error) => {
        console.error("Logo API Error:", error);
      })
      .finally(() => {
        setCallInProgress(false);
      });
  };
  const linkDestination = authToken
  ? enabled
    ? "/adminPortal"
    : "/dashboard"
  : "/welcome";
  return (
   <div className={classes.container}>
  <Hidden mdUp>
    <div className={classes.mobileHeader}>
      <IconButton onClick={handleDrawerToggle}>
        <MenuIcon />
      </IconButton>

      <Link to={linkDestination}>
        {logo && (
          <img src={logo} className={classes.logo} alt="Logo" />
        )}
      </Link>
    </div>
  </Hidden>

  <Hidden smDown>
    <Link to={linkDestination}>
      {logo && (
        <img src={logo} className={classes.logo} alt="Logo" />
      )}
    </Link>

    <DesktopHeader userDetailData={userDetailData} />
  </Hidden>
</div>
  );
};

Header.propTypes = {
  handleDrawerToggle: func,
};

export default Header;